import React from "react";
import './styles/Legal.css';


const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1 className="policy-title">Privacy Policy for</h1>
      <h1 className="policy-subtitle">Newro (Operated by NWRWTS Pty Ltd) </h1>
      <p className="policy-updated">Last updated: June 4, 2025</p>
      <p className="policy-updated">Jurisdiction: South Africa (POPIA-compliant), with international application</p>
      <h2 className="policy-section">1. Introduction </h2>
      <p className="policy-text">
        At NWRWTS Pty Ltd ("we", "us", or "our"), your privacy is important to us. This Privacy Policy
        explains how we collect, use, store, and protect your personal data when you use the Newro
        platform (website and mobile app). We are committed to handling your data in compliance with
        the Protection of Personal Information Act (POPIA) and other applicable privacy laws.
      </p>
      <h2 className="policy-section">2. Information We Collect</h2>
      <p className="policy-text">We collect the following types of information:</p>
      <p className="policy-text"><strong>a. Personal Information:</strong></p>
      <ul className="policy-list">
        <li>Name</li>
        <li>Email address</li>
        <li>Date of birth</li>
        <li>Gender (optional)</li>
        <li>Profile photo</li>
        <li>Fitness preferences</li>
      </ul>
      <p className="policy-text"><strong>b. Location Data:</strong></p>
      <ul className="policy-list">
        <li>Real-time location (used to suggest nearby events)</li>
      </ul>
      <p className="policy-text"><strong>c. Activity Data:</strong></p>
      <ul className="policy-list">
        <li>Events you attend or host</li>
        <li>Interactions with other users</li>
        <li>Optional fitness tracker integrations</li>
      </ul>
      <p className="policy-text"><strong>d. Technical Data:</strong></p>
      <ul className="policy-list">
        <li>Device and browser type</li>
        <li>IP address</li>
        <li>Usage data (pages viewed, clicks, session duration)</li>
      </ul>
      <h2 className="policy-section">3. How We Use Your Data</h2>
      <p className="policy-text">We use your data to:</p>
      <ul className="policy-list">
        <li>Create and manage your profile</li>
        <li>Match you with relevant groups, events, and users</li>
        <li>Show nearby activities using your location</li>
        <li>Improve the platform experience and safety</li>
        <li>Send service-related communications (e.g. confirmations, updates)</li>
        <li>Offer optional event recommendations based on activity preferences</li>
      </ul>
      <p className="policy-text">
        We do <strong>not</strong> sell or rent your data to third parties.
      </p>
      <h2 className="policy-section">4. Sharing of Data</h2>
      <p className="policy-text">We may share your data:</p>
      <ul className="policy-list">
        <li>With other users (e.g., your name and profile if you RSVP to an event)</li>
        <li>With service providers that help operate Newro (hosting, analytics, etc.)</li>
        <li>If required by law or legal process</li>
        <li>To protect the rights, safety, or property of NWRWTS Pty Ltd, Newro users, or the public</li>
      </ul>
      <h2 className="policy-section">5. Data Security</h2>
      <p className="policy-text">
        We implement reasonable administrative, technical, and physical safeguards to protect your data.
        However, no platform can be 100% secure. You are responsible for protecting your login credentials.
      </p>
      <h2 className="policy-section">6. Data Retention</h2>
      <p className="policy-text">
        We retain your data for as long as your account is active or as needed to fulfill legal or
        operational obligations. You may request deletion of your account and data at any time.
      </p>
      <h2 className="policy-section">7. Your Rights</h2>
      <p className="policy-text">
        Depending on your location, you may have the right to:
      </p>
      <ul className="policy-list">
        <li>Access the personal data we hold about you</li>
        <li>Correct inaccurate or incomplete data</li>
        <li>Delete your data (right to be forgotten)</li>
        <li>Object to or restrict processing</li>
        <li>Withdraw consent for optional data uses</li>
      </ul>
      <p className="policy-text">
        You can manage many of these through your account settings or by contacting us.
      </p>
      <h2 className="policy-section">8. Cookies &amp; Tracking</h2>
      <p className="policy-text">
        We use cookies and similar technologies for session management and analytics. You may
        disable cookies through your browser, but this may impact your experience.
      </p>
      <h2 className="policy-section">9. International Users</h2>
      <p className="policy-text">
        If you access Newro from outside South Africa, your data may be transferred to and processed
        in South Africa or other countries with different privacy laws. We ensure appropriate safeguards
        are in place for cross-border data transfers.
      </p>
      <h2 className="policy-section">10. Changes to This Policy</h2>
      <p className="policy-text">
        We may update this Privacy Policy from time to time. We will notify you of significant changes
        and post the updated policy on our website or app.
      </p>
      <h2 className="policy-section">11. Contact Us</h2>
      <p className="policy-text">
        For questions or data requests, contact us at:<br />
        <strong>events@newro.co.za</strong><br />
        NWRWTS Pty Ltd, Cape Town, South Africa
      </p>
    </div>
  );
};

export default PrivacyPolicy;
